import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  chakMarkWhite,
  deleteIconBlue,
  deleteIconCircleOrange,
  eyeClose,
  gallery1,
  gallery10,
  gallery11,
  gallery12,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  menuDotsIcon,
  modalCloseIcon,
  moveIocn,
  pinIocn,
  RestoreIcon,
} from "../../../../../images";
import Modal from "react-bootstrap/Modal";
import "./galleryPopupComn.scss";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import GallerypopupDeleteVariant from "./GallerypopupDeleteVariant";
import { useWindowSize } from "react-use";
import BottomSheetOptions from "./BottomSheetOptions";
import GalleryPopupMove from "./GalleryPopupMove";
import config from "../../../../../config/config";
import BlurGalleryImage from "../../../../../components/BlurGalleryImage/BlurGalleryImage";
import useTheme from "../../../../../components/useTheme/useTheme";

const GalleryPopupRecentlyDeleted = forwardRef((props, ref) => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [columns, setColumns] = useState(4); // Default: 4 columns
  const [checkedItems, setCheckedItems] = useState({});
  const [showMovePopup, setShowMovePopup] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const handleShowDeletePopupOpen = () => {
    setShowDeletePopup(true);
  };
  const handleShowDeletePopupClose = () => {
    // setSelectedImages([]);
    // setCheckedItems({});
    setShowDeletePopup(false);
  };

  const handleDeleteImages = (data) => props.onDeleteImages(data);
  const handleRestoreImages = () => {
    if (selectedImages.length > 0) {
      props.onRestoreImages(selectedImages);
      setCheckedItems({});
    }
  };
  const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
    useState(false);
  // const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
  //   useState(false);
  const aws_object_url = config.aws_object_url;

  useImperativeHandle(ref, () => ({
    handleShowDeletePopupClose,
    resetCheckedItems: () => {
      setSelectedImages([]);
      setCheckedItems({});
    },
  }));

  const handleCheckboxToggle = (key, item) => {
    setSelectedImages((prev) => {
      if (checkedItems[key]) {
        return prev.filter((selected) => selected.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const selectedCount = Object.values(checkedItems).filter(Boolean).length;

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(4);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  // Masonry logic: Arranging images row-wise instead of column-wise
  const createMasonryLayout = () => {
    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);
    const filteredImages = Object.values(
      props?.categoryData?.data?.recently_deleted || {},
    ).flat();
    filteredImages?.forEach((img) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights),
      );
      // arranged[shortestColumnIndex].push({
      //   id: img._id,
      //   section: img?.section || "recently_deleted", // you can adjust this field
      //   src: `${aws_object_url}recently_deleted/${img?.url}`,
      //   name: img?.url,
      // });
      arranged[shortestColumnIndex].push({
        id: img._id,
        section: img?.section || "recently_deleted",
        src: `${aws_object_url}recently_deleted/${img?.url}`,
        name: img?.url,
        width: img?.width,
        height: img?.height,
        blurHash: img?.blurHash,
        visibility: img?.visibility,
      });

      columnHeights[shortestColumnIndex] += 1; // Assuming equal height for each image
    });

    return arranged;
  };

  const arrangedImages = createMasonryLayout();
  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef(null);
  const handleGallerypopupDeleteVariantOpen = () =>
    setShowGallerypopupDeleteVariant(true);
  const handleGallerypopupDeleteVariantClose = () =>
    setShowGallerypopupDeleteVariant(false);
  const handleGallerypopupMoveOpen = () => setShowMovePopup(true);
  const handleGallerypopupMoveClose = () => setShowMovePopup(false);
  const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupClose = () => setShowOptionsPopup(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {width <= 768 && (
        <BottomSheetOptions
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={handleGallerypopupDeleteVariantOpen}
          handelOpenMove={handleGallerypopupMoveOpen}
        />
      )}
      <DeleteConfirmPopup
        theme={theme}
        show={showDeletePopup}
        handleClose={handleShowDeletePopupClose}
        headingSugested={"Add More Project Photos & Renders"}
        data={selectedImages}
        action={"permanent"}
        deleteImages={handleDeleteImages}
      />
      {/* <GallerypopupDeleteVariant
        show={showGallerypopupDeleteVariant}
        handleCloseDelete={handleGallerypopupDeleteVariantClose}
      /> */}
      {/* <GalleryPopupMove
        show={showMovePopup}
        handleCloseDelete={handleGallerypopupMoveClose}
      /> */}
      <Modal
        {...props}
        centered
        // className="Gallery_popup_modal gallery_popup_edit"
        className={`Gallery_popup_modal gallery_popup_edit  ${
          theme === "dark" && "nw_gl_popup--dark-mode"
        }`}
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button
            className="custom-cancel-btn"
            onClick={() => {
              setCheckedItems({});
              setSelectedImages([]);
              props.handleCloseDelete();
            }}
          >
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Gallery_popup_heading d-flex align-items-center">
            Recently Deleted
            {/* <div
              className="menu-wrapper"
              ref={menuRef}
              onClick={() => setIsHovered(!isHovered)}
            >
              <div className="three-dot-icon">
                <img
                  src={menuDotsIcon}
                  alt="menu"
                  className="menu_gallery_popup_edit_icon"
                  onClick={handleOptionsPopupOpen}
                />
              </div>
              <div className={`hover-menu ${isHovered ? "show" : "hide"}`}>
                <div className="menu-item">
                  <img
                    src={deleteIconCircleOrange}
                    alt=""
                    className="menu_icon_popup"
                  />{" "}
                  Delete Images
                </div>

                <div className="menu-item">
                  <img src={eyeClose} alt="" className="menu_icon_popup" /> Hide
                  Images
                </div>
                <div className="menu-item">
                  <img src={pinIocn} alt="" className="menu_icon_popup" /> Pin
                  Images
                </div>

                <div className="menu-item">
                  <img src={moveIocn} alt="" className="menu_icon_popup" /> Move
                  Images
                </div>
                <div className="menu-item border-0">Recently Deleted</div>
              </div>
            </div> */}
          </h2>

          <h3 className="popup_muted_title fst-italic">
            Deleted images are saved in “Recently Deleted” but excluded from AI
            matchmaking.
          </h3>
          <h3 className="popup_muted_title pb-2">
            {selectedCount} images selected
          </h3>
          <div className="masonry-gallery-two">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {column.map((item, index) => {
                  const itemKey = `${colIndex}-${index}`;
                  const isChecked = checkedItems[itemKey];

                  return (
                    <div
                      className="masonry-item position-relative"
                      key={itemKey}
                    >
                      {/* <div
                        className="img-skeleton-bg"
                        style={{
                          aspectRatio: "auto",
                        }}
                      >
                        <img
                          src={item.src}
                          alt={`Gallery ${index}`}
                          loading="lazy"
                          decoding="async"
                          onClick={() => handleCheckboxToggle(itemKey, item)}
                          style={{
                            cursor: "pointer",
                          }}
                          onLoad={(e) => {
                            // Set parent height based on loaded image
                            const imgHeight = e.target.offsetHeight;
                            console.log(imgHeight);
                            e.target.parentElement.style.minHeight = `${imgHeight}px`;
                          }}
                        />
                      </div> */}
                      <BlurGalleryImage
                        item={{
                          src: item.src,
                          width: item.width,
                          height: item.height,
                          blurHash: item.blurHash,
                          visibility: item.visibility,
                        }}
                        onClick={() => handleCheckboxToggle(itemKey, item)}
                      />

                      <div
                        onClick={() => handleCheckboxToggle(itemKey, item)}
                        className={`${
                          isChecked
                            ? "checked check_box_ctm_popup_wraper"
                            : "check_box_ctm_popup_wraper"
                        }`}
                      >
                        {/* Hidden input just to keep HTML semantics */}
                        <input
                          type="checkbox"
                          checked={isChecked || false}
                          onChange={() => {}}
                          className="hiden_ip_ctm_popup"
                        />

                        {isChecked && (
                          <img
                            src={chakMarkWhite}
                            alt="Checkmark"
                            className="chek_mark_ctm_popup"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          {selectedCount > 0 && (
            <div className="delete_gallery_image d-flex">
              <div
                className="delete_wrapper resotre_warperr"
                onClick={handleRestoreImages}
              >
                <img src={RestoreIcon} alt="delete" className="delete_icon" />
                Restore
              </div>
              <div
                className="delete_wrapper me-0"
                onClick={handleShowDeletePopupOpen}
              >
                <img
                  src={deleteIconBlue}
                  alt="delete"
                  className="delete_icon"
                />
                Permanently Delete
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
});

export default GalleryPopupRecentlyDeleted;
